import { Link } from "react-router-dom";
import { Logo } from "./Logo";

const PRODUCT_LINKS = [
  { id: "the-decision", label: "The Decision" },
  { id: "system", label: "Intelligence System" },
  { id: "deliverables", label: "Deliverables" },
  { id: "engagements", label: "Engagements" },
  { id: "why-enexur", label: "Why ENEXUR" },
];

const COMPANY_LINKS = [
  { href: "https://enexur.online/", label: "enexur.online" },
  { href: "https://enexur.online/about", label: "About" },
  { href: "https://enexur.online/privacy", label: "Privacy" },
  { href: "https://enexur.online/terms", label: "Terms" },
];

export const Footer = () => (
  <footer className="border-t border-gold/15 bg-abyss/60" data-testid="site-footer">
    <div className="wrap grid gap-14 py-16 md:grid-cols-12 md:py-20">
      <div className="md:col-span-5">
        <Logo />
        <p className="mt-8 max-w-sm text-[15px] leading-relaxed text-mist">
          ENEXUR Communication builds private, bespoke, evidence-led intelligence
          systems for international companies evaluating, entering, or scaling in India.
        </p>
        <a
          href="mailto:business@enexur.in"
          data-testid="footer-email"
          className="mt-8 inline-block border-b border-gold/40 pb-1 font-mono text-[12px] tracking-[0.18em] text-gold transition-colors hover:text-gold-soft"
        >
          BUSINESS@ENEXUR.IN
        </a>
      </div>

      <div className="md:col-span-3">
        <h3 className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold/70">
          Product
        </h3>
        <ul className="mt-6 space-y-3">
          {PRODUCT_LINKS.map((l) => (
            <li key={l.id}>
              <Link
                to={`/india-market-intelligence#${l.id}`}
                className="text-[14px] text-mist transition-colors hover:text-ivory"
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="md:col-span-2">
        <h3 className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold/70">
          Client Brief
        </h3>
        <ul className="mt-6 space-y-3">
          <li>
            <Link
              to="/client-intelligence-brief"
              data-testid="footer-brief-link"
              className="text-[14px] text-mist transition-colors hover:text-ivory"
            >
              Start your Client Intelligence Brief
            </Link>
          </li>
          <li>
            <Link
              to="/client-intelligence-brief"
              className="text-[14px] text-mist transition-colors hover:text-ivory"
            >
              Apply for an engagement
            </Link>
          </li>
        </ul>
      </div>

      <div className="md:col-span-2">
        <h3 className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold/70">
          Company
        </h3>
        <ul className="mt-6 space-y-3">
          {COMPANY_LINKS.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[14px] text-mist transition-colors hover:text-ivory"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>

    <div className="border-t border-gold/10">
      <div className="wrap flex flex-col items-start justify-between gap-3 py-6 font-mono text-[10px] uppercase tracking-[0.22em] text-mist/60 md:flex-row md:items-center">
        <span>© {new Date().getFullYear()} ENEXUR Communication</span>
        <span className="text-gold/50">ENEXUR India Market Intelligence™</span>
        <span>Private • Bespoke • Evidence-led</span>
      </div>
    </div>
  </footer>
);
